import type { ReactNode } from 'react';
import { LEO_SUITE } from '@/config/suite.config';
import { AppLogo } from '@/components/branding/app-logo';

interface AuthLayoutProps {
  children: ReactNode;
}

/**
 * Layout para páginas de autenticação
 */
export function AuthLayout({ children }: AuthLayoutProps) {
  return (
    <div className="flex min-h-screen">
      <div className="hidden lg:flex lg:w-1/2 flex-col justify-between bg-primary p-12 text-primary-foreground">
        <div>
          <div className="flex items-center gap-3">
            <AppLogo size="md" />
            <div>
              <span className="text-xl font-semibold">{LEO_SUITE.productName}</span>
              <span className="block text-xs uppercase tracking-wider text-primary-foreground/70">{LEO_SUITE.suiteName}</span>
            </div>
          </div>
        </div>
        <div className="space-y-4">
          <h1 className="text-4xl font-bold leading-tight">
            Gestão profissional para clínicas de bem-estar
          </h1>
          <p className="text-lg text-primary-foreground/80">
            Agenda, clientes, pagamentos e muito mais — tudo num só lugar.
          </p>
        </div>
        <p className="text-sm text-primary-foreground/60">
          © {new Date().getFullYear()} {LEO_SUITE.suiteName}. Todos os direitos reservados.
        </p>
      </div>
      <div className="flex flex-1 items-center justify-center p-6 bg-background">
        <div className="w-full max-w-md">{children}</div>
      </div>
    </div>
  );
}
